"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var classnames_1 = __importDefault(require("classnames"));
var useBinaryState_1 = __importDefault(require("stremio/common/useBinaryState"));
var useOrientation_1 = __importDefault(require("stremio/common/useOrientation"));
var BottomSheet_less_1 = __importDefault(require("./BottomSheet.less"));
var CLOSE_THRESHOLD = 100;
var BottomSheet = function (_a) {
    var _b;
    var children = _a.children, title = _a.title, show = _a.show, onClose = _a.onClose;
    var containerRef = (0, react_1.useRef)(null);
    var orientation = (0, useOrientation_1.default)();
    var _c = (0, react_1.useState)(0), startOffset = _c[0], setStartOffset = _c[1];
    var _d = (0, react_1.useState)(0), offset = _d[0], setOffset = _d[1];
    var _e = (0, useBinaryState_1.default)(), opened = _e[0], open = _e[1], close = _e[2];
    var containerStyle = (0, react_1.useMemo)(function () { return ({
        transform: "translateY(".concat(offset, "px)")
    }); }, [offset]);
    var containerHeight = function () { var _a, _b; return (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0; };
    var onCloseRequest = function () { return setOffset(containerHeight()); };
    var onTouchStart = function (_a) {
        var touches = _a.touches;
        var clientY = touches[0].clientY;
        setStartOffset(clientY);
    };
    var onTouchMove = (0, react_1.useCallback)(function (_a) {
        var touches = _a.touches;
        var clientY = touches[0].clientY;
        setOffset(Math.max(0, clientY - startOffset));
    }, [startOffset]);
    var onTouchEnd = function () {
        setOffset(function (offset) { return offset > CLOSE_THRESHOLD ? containerHeight() : 0; });
        setStartOffset(0);
    };
    var onTransitionEnd = (0, react_1.useCallback)(function () {
        (offset === containerHeight()) && close();
    }, [offset]);
    (0, react_1.useEffect)(function () {
        setOffset(0);
        show ? open() : close();
    }, [show]);
    (0, react_1.useEffect)(function () {
        !opened && onClose();
    }, [opened]);
    (0, react_1.useEffect)(function () {
        opened && close();
    }, [orientation]);
    return opened && (0, react_dom_1.createPortal)((react_1.default.createElement("div", { className: BottomSheet_less_1.default['bottom-sheet'] },
        react_1.default.createElement("div", { className: BottomSheet_less_1.default['backdrop'], onClick: onCloseRequest }),
        react_1.default.createElement("div", { ref: containerRef, className: (0, classnames_1.default)(BottomSheet_less_1.default['container'], (_b = {}, _b[BottomSheet_less_1.default['dragging']] = startOffset, _b), 'animation-slide-up'), style: containerStyle, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, onTransitionEnd: onTransitionEnd },
            react_1.default.createElement("div", { className: BottomSheet_less_1.default['heading'] },
                react_1.default.createElement("div", { className: BottomSheet_less_1.default['handle'] }),
                react_1.default.createElement("div", { className: BottomSheet_less_1.default['title'] }, title)),
            react_1.default.createElement("div", { className: BottomSheet_less_1.default['content'], onClick: onCloseRequest }, children)))), document.body);
};
exports.default = BottomSheet;
